import { useRef, useState, useCallback } from 'react';
import type { TurnstileInstance } from '@marsidev/react-turnstile';

const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined;

export function useTurnstile() {
  const [captchaToken, setCaptchaToken] = useState<string | undefined>(undefined);
  const turnstileRef = useRef<TurnstileInstance | null>(null);

  const onSuccess = useCallback((token: string) => {
    setCaptchaToken(token);
  }, []);

  const onError = useCallback(() => {
    setCaptchaToken(undefined);
  }, []);

  const onExpire = useCallback(() => {
    setCaptchaToken(undefined);
  }, []);

  const resetTurnstile = useCallback(() => {
    setCaptchaToken(undefined);
    turnstileRef.current?.reset();
  }, []);

  return {
    captchaToken,
    turnstileRef,
    siteKey: TURNSTILE_SITE_KEY,
    isTurnstileEnabled: !!TURNSTILE_SITE_KEY,
    onSuccess,
    onError,
    onExpire,
    resetTurnstile,
  };
}
